const Backbone = require('backbone')

import { ItensOrcamento } from './itemOrcamento'

import global from 'globalMU'
import { Ambientes } from './ambiente'
import store from 'app/redux/store/store'
import { IOrcamento } from 'app/types/IOrcamento'
import globalMU from 'globalMU'
import {sobrescreverInformacoesAction,  atualizarItensAction} from 'app/redux/orcamentoSlice'
import * as R from 'ramda'
import { obterParametro } from 'app/use-cases/parametro/obterParametro'

declare var window

enum AcaoAposIncluirProdutos {
    ADICIONAR_PRODUTOS_E_CONTINUAR_PESQUISANDO = "adicionar-produtos-continuar",
    ADICIONAR_PRODUTOS_E_CONTINUAR_NO_GRID = "ADICIONAR_PRODUTOS_E_CONTINUAR_NO_GRID"
}



const Orcamento = Backbone.Model.extend({
    name: "Orcamento",

    initialize: function () {
        // this.set("AtualizarDescontos", false);
        // this.set("AtualizarTotais", false);
        // this.set("AtualizarItens", false);
        // this.set("AtualizarParcelas", false);
        // this.set("AtualizarRemoto", true);
        // this.set("VerificarPendenciaFormaDePagamento", false);
        // this.set("VerificarPendenciaVendaFrete", false);
        // this.set("CalcularFreteAutomaticamente", false);
        //this.set("DescontoMaximoFormaPagamento", 0.00);
        //this.set("DescontoFretePorContaDestinatario", 0.00);
        //this.set("DescontoPorFaixaValorVenda", 0.00);
        //this.set("DescontoAdicionalProdutoSemOferta", 0.00);
        //this.set("DescontoAdicionalProdutoComOferta", 0.00);
        //this.iniciarEventos();
        //this.criarItensOrcamento();
        //this.verificarPendenciaFormaDePagamento();
        //this.verificarPendenciaVendaFrete();
    },

    iniciarEventos: function () {

        // this.on("change:CodigoCliente", this.clienteAlterado, this);
        // this.on('change:ItensOrcamento', this.atualizarTotaisOrcamento, this);
        // this.on("change:ValorDespesasInclusas", this.despesasInclusasAlterado, this);
        // this.on("change:ValorDesconto", this.valorDescontoAlterado, this);
        // this.on("change:ValorDescontoSobreMercadoriasNacionais", this.valorDescontoSobreMercadoriasNacionaisAlterado, this); // FNX-5558
        // this.on("change:ValorDescontoSobreMercadoriasImportadas", this.valorDescontoSobreMercadoriasImportadasAlterado, this); // FNX-5558
        // this.on("change:PercentualDesconto", this.percentualDescontoAlterado, this);
        // this.on("change:PercentualDescontoSobreMercadoriasNacionais", this.percentualDescontoSobreMercadoriasNacionaisAlterado, this); // FNX-5558
        // this.on("change:PercentualDescontoSobreMercadoriasImportadas", this.percentualDescontoSobreMercadoriasImportadasAlterado, this);  // FNX-5558
        // this.on("change:PercentualDescontoAcumulado", this.percentualDescontoAcumuladoAlterado, this);
        // this.on("change:ValorDescontoAcumulado", this.valorDescontoAcumuladoAlterado, this);
        // this.on("change:CodigoFormaPagamento", this.formaPagamentoAlterada, this);
        // this.on("change:ValorSeguroEntrega", this.valorSeguroEntregaAlterado, this);
        // this.on("change:PercentualSeguroEntrega", this.percentualSeguroEntregaAlterado, this);
        // this.on("change:ValorFrete", this.valorFreteAlterado, this);
        // this.on("change:ValorAcrescimoFinanceiro", this.valorAcrescimoFinanceiroAlterado, this);
        // this.on("change:ClienteNaoCadastrado", this.clienteNaoCadastradoAlterado, this);
        // this.on("change:Transportadora", this.valorTransportadoraAlterado, this);
        // $("#valor-frete").keyup($.proxy(this.cancelarCalcularFreteAutomaticamente, this));

    },

    desatacharEventos: function () {
        this.e = $.extend(this._events, {}, true);
        this._events = null;
    },

    atacharEventos: function () {

        if (this.e) {
            this._events = $.extend(this.e, {}, true);
            this.e = null;
        }
        $("input").on('focus', function () { $(this).select(); });

    },

    reiniciarEventos: function () {
        this.desatacharEventos();
        this.atacharEventos();
    },

    criarItensOrcamento: function () {
        if (!this.get("ItensOrcamento")) {
            var itensOrcamento = new ItensOrcamento();
            itensOrcamento.orcamento = this;
            this.set("ItensOrcamento", itensOrcamento);
        }
    },

    selecionarCliente: function (cliente) {

        if (!this.get("Cliente")) {
            this.set("Cliente", cliente);
        }
    },

    clienteAlterado: function () {
        if (!this.get("CodigoCliente")) {
            this.removerCliente();
        }
    },

    clienteNaoCadastradoAlterado: function () {
        if (!this.get("ClienteNaoCadastrado")) {
            this.removerCliente();
        }
    },

    removerCliente: function () {
        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/RemoverCliente",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento")
            }),
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                self.atualizar(data);
                global.unblockUI();
            }
        });

    },

    atualizarTotaisOrcamento: function () {

        var self = this;
        global.blockUI();
        global.ajax({
            blockUI: false,
            url: "/Orcamento/ObterTotaisOrcamento",
        type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento")
            }),
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();

            }
        });

    },

    atualizar: function (data : IOrcamento,ehParaAtualizarEstadoLegado = true, ehParaAtualizarRedux = true, silent = false) {

        if (ehParaAtualizarEstadoLegado == false) {
            console.warn('orcmento.atualizar chamado com ehParaAtualizarEstadoLegado = false. atualizacao tardia do estado legado foi descontinuada, agora o estado do redux e do legado sempre sao atualizados')
            ehParaAtualizarEstadoLegado = true
        }

        if (!data) {
            return;
        }
/*
        const atualizarEstadoLegado = () => {
            const setOptions = {silent}

            this.set("AtualizandoOrcamentoViaJS", true,setOptions);// FNX-4826

            this.set("ValorIPI", data.ValorIPI,setOptions);
            this.set("ValorTotalMercadorias", data.ValorTotalMercadorias,setOptions);
            this.set("ValorDespesasInclusas", data.ValorDespesasInclusas,setOptions);
            this.set("PercentualDesconto", data.PercentualDesconto,setOptions);
            this.set("ValorDesconto", data.ValorDesconto,setOptions);
            //
            this.set("ValorTotalMercadoriasNacionais", data.ValorTotalMercadoriasNacionais,setOptions); // FNX-5558
            this.set("ValorTotalMercadoriasImportadas", data.ValorTotalMercadoriasImportadas,setOptions);
            this.set("PercentualDescontoSobreMercadoriasNacionais", data.PercentualDescontoSobreMercadoriasNacionais,setOptions);
            this.set("PercentualDescontoSobreMercadoriasImportadas", data.PercentualDescontoSobreMercadoriasImportadas,setOptions);
            this.set("ValorDescontoSobreMercadoriasNacionais", data.ValorDescontoSobreMercadoriasNacionais,setOptions);
            this.set("ValorDescontoSobreMercadoriasImportadas", data.ValorDescontoSobreMercadoriasImportadas,setOptions); // FNX-5558
            this.set("TipoTratamentoDesconto", data.TipoTratamentoDesconto,setOptions); // FNX-5558
            //
            this.set("DescontoAcumulado", data.DescontoAcumulado,setOptions);
            this.set("PercentualDescontoAcumulado", data.PercentualDescontoAcumulado,setOptions);
            this.set("ValorAcrescimoFinanceiro", data.ValorAcrescimoFinanceiro,setOptions);
            this.set("ValorFrete", data.ValorFrete,setOptions);
            this.set("PercentualFrete", data.PercentualFrete,setOptions); // 445689
            this.set("SubTotal", data.SubTotal,setOptions);
            this.set("ValorTotal", data.ValorTotal,setOptions);
            this.set("ValorTotalSolicitado", data.ValorTotalSolicitado,setOptions);
            this.set("ValorTotalPendente", data.ValorTotalPendente,setOptions);
            this.set("ValorSubstituicao", data.ValorSubstituicao,setOptions);
            this.set("ValorSeguroEntrega", data.ValorSeguroEntrega,setOptions);
            //438892 cashback     
            this.set("SaldoCashbackCliente", data.SaldoCashbackCliente,setOptions);
            //this.set("SaldoCashbackCliente", data.SaldoCashbackCliente,setOptions);
            this.set("ValidadeCashbackCliente", data.ValidadeCashbackCliente,setOptions);
            this.set("ValorCashbackUtilizado", data.ValorCashbackUtilizado,setOptions);
            this.set("AplicaDescontoCashback", data.AplicaDescontoCashback,setOptions);

            this.set("PercentualSeguroEntrega", data.PercentualSeguroEntrega,setOptions);
            this.set("PerdaCotacao", data.PerdaCotacao,setOptions);
            this.set("ValorDescontoAcumuladoSobreMercadoriasNacionais", data.ValorDescontoAcumuladoSobreMercadoriasNacionais,setOptions)
            this.set("ValorDescontoAcumuladoSobreMercadoriasImportadas", data.ValorDescontoAcumuladoSobreMercadoriasImportadas, setOptions)
            this.set("PercentualDescontoAcumuladoSobreMercadoriasNacionais", data.PercentualDescontoAcumuladoSobreMercadoriasNacionais, setOptions)
            this.set("PercentualDescontoAcumuladoSobreMercadoriasImportadas", data.PercentualDescontoAcumuladoSobreMercadoriasImportadas, setOptions)

            this.set("ManterReserva", data.ManterReserva, setOptions);   // 455920/74856
            this.set("OidFornecedorPorRepresentacao", data.OidFornecedorPorRepresentacao, setOptions);   // 456252

            this.set("ValorDescontoIcms", data.ValorDescontoIcms,setOptions); // FNX-4794
            //this.set("RecalcularPrecos", data.RecalcularPrecos,setOptions); // 419846
            this.set("PossuiPendenciaDesconto", data.PossuiPendenciaDesconto,setOptions); // 450413

            if (data.hasOwnProperty("CodigoFormaPagamento")) {
                this.set("CodigoFormaPagamento", data.CodigoFormaPagamento,setOptions);
            }

            if (data.hasOwnProperty("CodigoTipoDocumento")) {
                this.set("CodigoTipoDocumento", data.CodigoTipoDocumento,setOptions);
            }

            if (data.hasOwnProperty("ItensOrcamento")) {
                this.atualizarItens(data.ItensOrcamento, true, false, silent);
            }


            if (data.hasOwnProperty("ParcelasFormaPagamento")) {
                this.atualizarParcelasFormaPagamento(data, true, false, silent);
            }
            
            if (data.hasOwnProperty("Situacao")) {
                this.set("Situacao", data.Situacao,setOptions);
            }

            if (data.hasOwnProperty("CodigoMotivoDesconto")) {
                this.set("CodigoMotivoDesconto", data.CodigoMotivoDesconto,setOptions);
            }
            
            this.set("IdCanalDeVenda", data.IdCanalDeVenda,setOptions); // 422642

            this.set("TipoEntregaPadrao", data.TipoEntregaPadrao,setOptions); // 474918

            this.set("AtualizandoOrcamentoViaJS", false,setOptions); // FNX-4826
            this.set("AtualizarRemoto", true,setOptions);
            this.set("AtualizarTotais", !this.get("AtualizarTotais"),setOptions);
            this.set("AtualizarDescontos", !this.get("AtualizarDescontos"),setOptions);

            this.set('RecalcularParcelas', data.RecalcularParcelas, setOptions)

            this.set('AptoParaGestaoDeFretes', data.AptoParaGestaoDeFretes, setOptions)

            // if (this.get("CalcularFreteAutomaticamente")) {
            //     self.calcularFreteAutomaticamente();
            // } else {
            //     self.verificarPendenciaFrete();
            //     self.set("CalcularFreteAutomaticamente", true);
            //     store.dispatch(sobrescreverInformacoesAction({CalcularFreteAutomaticamente: true}))
            // }

            // this.set("AtualizandoOrcamentoViaJS", false); // FNX-4826
        }
            */

        const atualizarRedux = () => {
            store.dispatch(sobrescreverInformacoesAction({AtualizandoOrcamentoViaJS: true}))

            store.dispatch(sobrescreverInformacoesAction(R.pick([
                "ValorIPI",
                "ValorTotalMercadorias",
                "ValorDespesasInclusas",
                "PercentualDesconto",
                "ValorDesconto",
                "ValorTotalMercadoriasNacionais",
                "ValorTotalMercadoriasImportadas",
                "PercentualDescontoSobreMercadoriasNacionais", 
                "PercentualDescontoSobreMercadoriasImportadas",
                "PercentualDescontoPadraoCliente",
                "ValorDescontoSobreMercadoriasNacionais",
                "ValorDescontoSobreMercadoriasImportadas",
                "TipoTratamentoDesconto",
                "DescontoAcumulado",
                "PercentualDescontoAcumulado",
                "ValorAcrescimoFinanceiro",
                "ValorFrete",
                "PercentualFrete", // 445689
                "SubTotal",
                "ValorTotal",
                "ValorTotalSolicitado",
                "ValorTotalPendente",
                "ValorSubstituicao",
                "ValorSeguroEntrega",
                "PercentualSeguroEntrega",
                "PerdaCotacao",
                "ValorDescontoIcms",
                "ValorDescontoIcmsDesonerado", // 428915/313149
                "CodigoFormaPagamento",
                "CodigoTipoDocumento",
                "UltimaAtualizacao",
                "AptoParaGestaoDeFretes",
                "DataMaximaParaPrevisaoEntrega",
                "CodigoMotivoDesconto",
                "IdCanalDeVenda", // 422642
                "RecalcularParcelas",
                "ValorDescontoAcumuladoSobreMercadoriasNacionais",
                "ValorDescontoAcumuladoSobreMercadoriasImportadas",
                "PercentualDescontoAcumuladoSobreMercadoriasNacionais",
                "PercentualDescontoAcumuladoSobreMercadoriasImportadas",
                "RecalcularPrecos",
                "PendenciaAcrescimoFinanceiro",
                "PossuiPendenciaDesconto", //450413
                "SaldoCashbackCliente",
                "ValidadeCashbackCliente",
                "ValorCashbackUtilizado",
                "AplicaDescontoCashback",
                "ManterReserva",  // 455920/74856
                "OidFornecedorPorRepresentacao", // 456252
                "LimiteCreditoCliente", // 448734
                "LimiteCreditoClienteBloqueado",// 448734
                "LimiteCreditoClientePendenciaFinanceira",// 448734
                "TipoEntregaPadrao", // 474918
                "ElegivelParaEmailCobrancaPixPrazo", // 414608
                "AtivarRecebimentoPixAPrazo", // 414608
                "ValorServicoAdicionalDespesa",
                "Indicador", // 478042
            ],data)))
            if (data.hasOwnProperty("ItensOrcamento")) {
                this.atualizarItens(data.ItensOrcamento, false, true);
            }

            if (data.hasOwnProperty("ParcelasFormaPagamento")) {
                this.atualizarParcelasFormaPagamento(data, false, true);
            }

            store.dispatch(sobrescreverInformacoesAction({AtualizandoOrcamentoViaJS: false}))
            store.dispatch(sobrescreverInformacoesAction({AtualizarRemoto: true}))
            // store.dispatch(sobrescreverInformacoesAction({AtualizarTotais: !store.getState().orcamento.AtualizarTotais}))
            // store.dispatch(sobrescreverInformacoesAction({AtualizarDescontos: !store.getState().orcamento.AtualizarDescontos}))

            // if (this.get("CalcularFreteAutomaticamente")) {
            //     self.calcularFreteAutomaticamente();
            // } else {
            //     self.verificarPendenciaFrete();
            //     self.set("CalcularFreteAutomaticamente", true);
            //     store.dispatch(sobrescreverInformacoesAction({CalcularFreteAutomaticamente: true}))
            // }

            // store.dispatch(sobrescreverInformacoesAction({AtualizandoOrcamentoViaJS: false}))
        }

        //if (!this.get("AtualizandoOrcamentoViaJS")) {// FNX-4826

            // if (ehParaAtualizarEstadoLegado) {
            //     atualizarEstadoLegado()
            // }
    
            //if (ehParaAtualizarRedux) {
                atualizarRedux()
            //}
        //}
    },
/*
    restaurarOrdenacao: function () {

        var itensSemOrdenacao = global.sessionStorage.getData(global.consts.itensSemOrdenacao);
        if (itensSemOrdenacao) {
            this.atualizarItens(itensSemOrdenacao);
        }
    },
*/
    atualizarParcelasFormaPagamento: function (data, ehParaAtualizarEstadoLegado = true, ehParaAtualizarRedux = true, silent = false) {

        if (!data) {
            return;
        }

        const atualizarEstadoLegado = () => {
            const setOptions = {silent}

            this.set("ParcelasFormaPagamento", data.ParcelasFormaPagamento,setOptions);
            
            globalMU.togglePropriedadeBooleanaBackbone(this,"AtualizarParcelas")

        }

        const atualizarRedux = () => {
            store.dispatch(sobrescreverInformacoesAction({
                ParcelasFormaPagamento: data.ParcelasFormaPagamento,
                AtualizarParcelas: false
            }))
        }

        if (ehParaAtualizarEstadoLegado) {
            
            atualizarEstadoLegado()
        }

        if (ehParaAtualizarRedux) {
            
            atualizarRedux()
        }

    },

    obterItensAmbiente: function (ambiente) {

        if (!this.get("ItensOrcamento")) {
            return null;
        }

        var itensOrcamento = new ItensOrcamento();

        this.get("ItensOrcamento").each(function (model) {
            var a = model.get("Ambiente");

            if (a && a == ambiente) {
                itensOrcamento.add(model);
            }

            if (!a && ambiente == "Não definido") {
                itensOrcamento.add(model);
            }

        });

        return itensOrcamento;
    },

    obterAmbientes: function () {

        var itensOrcamento = this.get("ItensOrcamento");

        if (!itensOrcamento) {
            return null;
        }

        var ambientes = new Ambientes();

        itensOrcamento.each(function (model) {

            var a = model.get("Ambiente");

            if (a && ambientes.where({ Ambiente: a }).length == 0) {
                ambientes.add({
                    Ambiente: a,
                    CorAmbiente: model.get("CorAmbiente"),
                    Quantidade: global.sum(itensOrcamento.where({ Ambiente: a }), "Quantidade"),
                    PrecoTotal: global.sum(itensOrcamento.where({ Ambiente: a }), "ValorTotal")
                });
            }

            if (!a && ambientes.where({ Ambiente: "Não definido" }).length == 0) {
                ambientes.add({
                    Ambiente: "Não definido",
                    CorAmbiente: "#c4c4c4",
                    Quantidade: global.sum(itensOrcamento.where({ Ambiente: "" }), "Quantidade"),
                    PrecoTotal: global.sum(itensOrcamento.where({ Ambiente: a }), "ValorTotal")
                });
            }

        });

        return ambientes;
    },

    despesasInclusasAlterado: function () {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        var vrDespInclusas = this.get("ValorDespesasInclusas")

        if (vrDespInclusas !== undefined && vrDespInclusas != null) {
            global.blockUI();
            global.ajax({
                url: "/Orcamento/DefinirDespesasInclusas",
                type: "post",
                contentType: "application/json",
                data: global.toJSONString({
                    identificadorOrcamento: this.get("IdentificadorOrcamento"),
                    valorDespesasInclusas: vrDespInclusas
                }),
                error: function () { global.unblockUI(); },
                success: function (data) {
                    global.blockUI();
                    if (data) {

                        self.atualizar(data);

                        var itensOrcamento = self.get("ItensOrcamento");
                        var valorDespesasInclusas = self.get("ValorDespesasInclusas");

                        if (itensOrcamento && (!valorDespesasInclusas || valorDespesasInclusas == 0)) {
                            itensOrcamento.each(function (model) {
                                model.set("DespesasInclusas", false);
                            });
                        }

                    }
                    global.unblockUI();
                }
            });
        }
    },

valorDescontoSobreMercadoriasNacionaisAlterado: function () { // FNX-5558

        if (!this.get("AtualizarRemoto") || this.get("AtualizandoOrcamentoViaJS")) {
            return;
        }
        global.blockUI();
        var self = this;
        
        global.ajax({
            url: "/Orcamento/DefinirDescontoSobreMercadorias",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valor: this.attributes.ValorDescontoSobreMercadoriasNacionais,
                tipo: "ValorDescontoNacional",
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });
    },

    valorDescontoSobreMercadoriasImportadasAlterado: function () { // FNX-5558
        
        if (!this.get("AtualizarRemoto") || this.get("AtualizandoOrcamentoViaJS")) {
            return;
        }
        global.blockUI();
        var self = this;
        
        global.ajax({
            url: "/Orcamento/DefinirDescontoSobreMercadorias",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valor: this.attributes.ValorDescontoSobreMercadoriasImportadas,
                tipo: "ValorDescontoImportado",
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });
    },


    valorDescontoAlterado: function (orcamentoModificado) {

        if (!this.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirValorDesconto",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valorDesconto: this.get("ValorDesconto")
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });

    },

    percentualDescontoAlterado: function (orcamentoModificado) {
        


        if (!this.get("AtualizarRemoto")) {
            return;
        }

        // if (orcamentoModificado?.changed?.PercentualDesconto == orcamentoModificado?.attributes.PercentualDesconto) {
        //     console.log(`PercentualDesconto não modificado.. Nada será feito. ${orcamentoModificado?.attributes?.PercentualDesconto}`)
        //     return
        // }

        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirPercentualDesconto",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                percentualDesconto: this.get("PercentualDesconto")
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });

    },

    percentualDescontoSobreMercadoriasNacionaisAlterado: function () { //FNX-5558

        if (!this.get("AtualizarRemoto") || this.get("AtualizandoOrcamentoViaJS")) {
            return;
        }
        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDescontoSobreMercadorias",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valor: this.attributes.PercentualDescontoSobreMercadoriasNacionais,
                tipo: "PercentualDescontoNacional",
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });
    },

    percentualDescontoSobreMercadoriasImportadasAlterado: function () { //FNX-5558

        if (!this.get("AtualizarRemoto") || this.get("AtualizandoOrcamentoViaJS")) {
            return;
        }
        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDescontoSobreMercadorias",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valor: this.attributes.PercentualDescontoSobreMercadoriasImportadas,
                tipo: "PercentualDescontoImportado",
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });
    },

    //@Deprecated
    percentualDescontoAcumuladoAlterado: function () {
        
        if (!this.get("AtualizarRemoto") || this.get("AtualizandoOrcamentoViaJS")) {
            return;
        }

        var self = this;
        global.blockUI();
        global.ajax({
            url: "/Orcamento/DefinirPercentualDescontoAcumulado",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                percentualDescontoAcumulado: this.get("PercentualDescontoAcumulado")
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();
            }
        });

    },

    valorDescontoAcumuladoAlterado: function (orcamentoModificado) {


        
        if (!this.get("AtualizarRemoto") || this.get("AtualizandoOrcamentoViaJS")) {
            return;
        }


        var agora = new Date(); // pode excluir essas linhas
        var inicio = agora.getTime()

        var self = this;
        global.blockUI();

        global.ajax({
            url: "/Orcamento/DefinirValorDescontoAcumulado",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valorDescontoAcumulado: this.get("ValorDescontoAcumulado")
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                global.blockUI();
                if (data) {
                    self.atualizar(data);
                }
                global.unblockUI();

            }
        });

    },

    planoPagamentoAlterado: function () {


        if (this.get("CodigoPlanoPagamento")) {
            this.unset("CodigoFormaPagamento");
            this.unset("CodigoTipoDocumento");
            store.dispatch(sobrescreverInformacoesAction({CodigoFormaPagamento: undefined, CodigoTipoDocumento: undefined}))
        }

        var self = this;

        if (!this.get("CodigoPlanoPagamento")) {


            global.ajax({
                url: "/Orcamento/RemoverPlanoPagamento",
                type: "post",
                data: {
                    identificadorOrcamento: this.get("IdentificadorOrcamento")
                },
                success: function (data) {
                    self.unset("CodigoParcelaPlanoPagamento");
                    self.unset("CodigoCarenciaPlanoPagamento");
                    self.unset("CodigoDocumentoPlanoPagamento");
                    self.unset("NomeDocumentoPlanoPagamento");

                    store.dispatch(sobrescreverInformacoesAction({
                        CodigoParcelaPlanoPagamento: undefined, 
                        CodigoCarenciaPlanoPagamento: undefined, 
                        CodigoDocumentoPlanoPagamento: undefined,
                        NomeDocumentoPlanoPagamento: undefined}))
                }
            });


            return;
        }


        global.ajax({
            url: "/Orcamento/DefinirPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                codigoPlanoPagamento: this.get("CodigoPlanoPagamento")
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                self.set("CodigoParcelaPlanoPagamento", data.CodigoParcelaPlanoPagamento);
                self.set("CodigoCarenciaPlanoPagamento", data.CodigoCarenciaPlanoPagamento);
                self.set("CodigoDocumentoPlanoPagamento", data.CodigoDocumentoPlanoPagamento);
                self.set("NomeDocumentoPlanoPagamento", data.NomeDocumentoPlanoPagamento);
            }
        });
    },

    parcelaPlanoPagamentoAlterado: function () {

        if (!this.get("CodigoParcelaPlanoPagamento")) {
            return;
        }

        global.ajax({
            url: "/Orcamento/DefinirParcelaPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                codigoParcela: this.get("CodigoParcelaPlanoPagamento")
            }
        });

    },

    carenciaPlanoPagamentoAlterado: function () {

        if (!this.get("CodigoCarenciaPlanoPagamento")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirCarenciaPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                codigoCarencia: this.get("CodigoCarenciaPlanoPagamento")
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                self.set("CodigoDocumentoPlanoPagamento", data.Codigo);
                self.set("NomeDocumentoPlanoPagamento", data.Nome);

            }
        });

    },

    planoPagamentoComEntradaAlterado: function () {

        if (this.get("PlanoPagamentoComEntrada") == undefined) {
            return;
        }

        global.ajax({
            url: "/Orcamento/DefinirPlanoPagamentoComEntrada",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                comEntrada: this.get("PlanoPagamentoComEntrada")
            }
        });

    },

    formaPagamentoAlterada: function () {

        if (this.get("CodigoFormaPagamento")) {
            this.unset("CodigoPlanoPagamento");
            this.unset("CodigoParcelaPlanoPagamento");
            this.unset("CodigoCarenciaPlanoPagamento");
            this.unset("PlanoPagamentoComEntrada");
            this.unset("CodigoDocumentoEntrada");
            this.unset("ValorEntrada");
            this.unset("UtilizaPlanoPagamento");

            store.dispatch(sobrescreverInformacoesAction({
                CodigoPlanoPagamento: undefined,
                CodigoParcelaPlanoPagamento: undefined,
                CodigoCarenciaPlanoPagamento: undefined,
                PlanoPagamentoComEntrada: undefined,
                CodigoDocumentoEntrada: undefined,
                ValorEntrada: undefined,
                UtilizaPlanoPagamento: undefined
            }))

        } else {
            var self = this;

            this.unset("CodigoTipoDocumento");
            store.dispatch(sobrescreverInformacoesAction({CodigoTipoDocumento: undefined}))

            global.ajax({
                url: "/Orcamento/RemoverFormaPagamento",
                type: "post",
                data: {
                    identificadorOrcamento: this.get("IdentificadorOrcamento")
                },
                success: function (data) {

                    if (!data) {
                        return;
                    }

                    self.set("ValorAcrescimoFinanceiro", global.formatNumber(data.ValorAcrescimoFinanceiro));
                    self.set("ValorTotalMercadorias", data.ValorTotalMercadorias);
                    self.set("ValorDespesasInclusas", data.ValorDespesasInclusas);
                    self.set("ValorTotal", data.ValorTotal);
                    self.set("ValorTotalPendente", data.ValorTotalPendente);
                }
            });
        }

    },

    //@Deprecated
    valorAcrescimoFinanceiroAlterado: function () {


        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        var valorAcrescimoFinanceiro = this.get("ValorAcrescimoFinanceiro");

        if (!valorAcrescimoFinanceiro) {
            return;
        }

        global.ajax({
            url: "/Orcamento/DefinirValorAcrescimoFinanceiro",
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valorAcrescimoFinanceiro: valorAcrescimoFinanceiro
            },
            success: function (data) {

                if (data) {
                    self.atualizar(data);
                }
            }
        });

    },

    atualizarItens: function (itens,ehParaAtualizarEstadoLegado = true, ehParaAtualizarRedux = true, silent = false) {

        const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]

        const atualizarEstadoLegado = () => {
            const setOptions = {silent}

            if (itens && itens.length > 0) {
                this.set("ItensOrcamento", new ItensOrcamento(itens, { orcamento: this }),setOptions);
            } else {
                this.unset("ItensOrcamento");
            }

            //this.set("AtualizarItens", !this.get("AtualizarItens"));
            
        }

        const atualizarRedux = () => {
            if (itens && itens.length > 0) {
                store.dispatch(atualizarItensAction({itens, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))

            } else {
                store.dispatch(atualizarItensAction({itens: null, acao: "SOBRESCREVER", corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
            }

            // store.dispatch(sobrescreverInformacoesAction({AtualizarItens: !store.getState().orcamento.AtualizarItens}))
        }

        
/*
        if (!this.OrdemAlterada) {
            global.sessionStorage.setData(global.consts.itensSemOrdenacao, itens);
        }
*/
        if (ehParaAtualizarEstadoLegado) {
            atualizarEstadoLegado()
        }

        if (ehParaAtualizarRedux) {
            atualizarRedux()
        }
        
    },

    atualizarItem: function (itens) {

        const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]

        if (itens && itens.length > 0) {
            var itensOrcamento = this.get("ItensOrcamento");
            var itensAtualizados = [];

            itensOrcamento.forEach(function (itemOrcamento) {
                itensAtualizados.push(itemOrcamento.toJSON());
            });

            itens.forEach(function (item) {
                var atualizar = null;

                itensAtualizados.forEach(function (itemAtualizado, index) {
                    if (item.Codigo === itemAtualizado.Codigo) {
                        atualizar = index;
                        return;
                    }
                });

                if (atualizar === null) {
                    return;
                }

                itensAtualizados[atualizar] = item;
            });

            this.set("ItensOrcamento", new ItensOrcamento(itensAtualizados, { orcamento: this }));
            store.dispatch(atualizarItensAction({itens: itensAtualizados, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
        } else {
            this.unset("ItensOrcamento");
            store.dispatch(atualizarItensAction({itens: [], acao: "ANEXAR",corPorAmbiente: store.getState().corPorAmbiente,valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
        }

        // const AtualizarItensVal = !this.get("AtualizarItens");
        // this.set("AtualizarItens", AtualizarItensVal);
        // store.dispatch(sobrescreverInformacoesAction({AtualizarItens: AtualizarItensVal}))
    },

    //@Deprecated
    valorFreteAlterado: function (orcamentoModificado) {

        if (!this.get("AtualizarRemoto")) {
            return;
        }
        var self = this;
        var vrFrete = this.get("ValorFrete")

        if (vrFrete !== undefined && vrFrete !== null) {
            global.blockUI();
            global.ajax({
                url: "/Orcamento/DefinirValorFrete",
                type: "post",
                data: {
                    identificadorOrcamento: this.get("IdentificadorOrcamento"),
                    valorFrete: vrFrete,
                },
                error: function () { global.unblockUI(); },
                success: function (data) {

                    if (!data || data.HasErrors) {
                        return;
                    }
                    global.blockUI();
                    self.atualizar(data);
                    global.unblockUI();
                }
            });
        }

    },

    valorTransportadoraAlterado: async function () {
        var self = this;

        const TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM = await obterParametro({nome: "TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM"})

        if (TRABALHA_FRETE_POR_FAIXA_PESO_CUBAGEM != "S") {
            self.calcularFreteAutomaticamente()
        }
    },

    //@Deprecated
    valorSeguroEntregaAlterado: function (orcamentoModificado) {

        if (!this.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI(); // FNX-5538
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirValorSeguroEntrega",
            type: "post",
            blockUI: true,  // FNX-5538
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                valorSeguroEntrega: this.get("ValorSeguroEntrega")
            },
            success: function (data) {
                global.blockUI(); // FNX-5538
                if (data) {
                    self.atualizar(data);
                    global.blockUI(); // FNX-5538
                }
                global.unblockUI(); // FNX-5538
            }
        });
    },

    //@Deprecated
    percentualSeguroEntregaAlterado: function (orcamentoModificado) {

        if (!this.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI(); // FNX-5538
        var self = this;
        var percSegEntrega = this.get("PercentualSeguroEntrega")

        if (percSegEntrega !== undefined && percSegEntrega != null) {

            global.ajax({
                url: "/Orcamento/DefinirPercentualSeguroEntrega",
                type: "post",
                blockUI: true,  // FNX-5538
                data: {
                    identificadorOrcamento: this.get("IdentificadorOrcamento"),
                    percentualSeguroEntrega: percSegEntrega
                },
                success: function (data) {
                    global.blockUI(); // FNX-5538
                    if (data) {
                        global.blockUI(); // FNX-5538
                        self.atualizar(data);
                        global.blockUI(); // FNX-5538
                    }
                    global.unblockUI(); // FNX-5538
                }
            });
        }

    },

    verificarPendenciaFormaDePagamento: function () {

        // var self = this;

        // global.ajax({
        //     url: "/Orcamento/VerificarPendenciaFormaDePagamento",
        //     type: "get",
        //     contentType: "application/json",
        //     success: function (data) {
        //         if (data && data === true) {
        //             self.set("VerificarPendenciaFormaDePagamento", true);
        //             store.dispatch(sobrescreverInformacoesAction({VerificarPendenciaFormaDePagamento: true}))
        //         }
        //     }
        // });

    },

    verificarPendenciaVendaFrete: function () {

        // var self = this;

        // global.ajax({
        //     url: "/Orcamento/VerificarPendenciaVendaFrete",
        //     type: "get",
        //     contentType: "application/json",
        //     success: function (data) {
        //         if (data && data === true) {
        //             self.set("VerificarPendenciaVendaFrete", true);
        //             self.set("CalcularFreteAutomaticamente", true);
        //             store.dispatch(sobrescreverInformacoesAction({CalcularFreteAutomaticamente: true, VerificarPendenciaVendaFrete: true}))

        //             self.verificarPendenciaFrete();
        //         }
        //     }
        // });

    },

    cancelarCalcularFreteAutomaticamente: function () {
        var self = this;

        if (self.get("CalcularFreteAutomaticamente")) {
            self.set("CalcularFreteAutomaticamente", false);
            store.dispatch(sobrescreverInformacoesAction({CalcularFreteAutomaticamente: false}))
        }
    },

    calcularFreteAutomaticamente: function () {
        var self = this;

        var verificarPendenciaVendaFrete = this.get("VerificarPendenciaVendaFrete");
        if (verificarPendenciaVendaFrete) {
            setTimeout(function () {
                global.ajax({
                    url: "/Orcamento/CalcularFreteAutomaticamente",
                    type: "post",
                    contentType: "application/json",
                    data: global.toJSONString({
                        codigoFilialOrcamento: self.get("CodigoFilialOrcamento"),
                        codigoCliente: self.get("CodigoCliente"),
                        tipoTransportadora: self.get("Transportadora").TipoTransportadora,
                        valorOrcamento: self.get("ValorTotalMercadorias")
                    }),
                    success: function (response) {
                        global.blockUI(); // FNX-5538
                        if (response && response.Frete !== undefined) {
                            self.set("ValorFrete", response.Frete);
                        } else {
                            self.set("ValorFrete", 0);
                        }

                        $("#lbValorFrete").css("color", "#000 !important");
                        $("#valor-frete").removeClass("erro");
                        global.unblockUI(); // FNX-5538
                    }
                });
            });
        }
    },

    verificarPendenciaFrete: function () {
        var self = this;
        var verificarPendenciaVendaFrete = this.get("VerificarPendenciaVendaFrete");
        if (verificarPendenciaVendaFrete) {
            setTimeout(function () {
                global.ajax({
                    url: "/Orcamento/PendenciaVendaFrete",
                    type: "post",
                    contentType: "application/json",
                    data: global.toJSONString({
                        codigoFilialOrcamento: self.get("CodigoFilialOrcamento"),
                        codigoCliente: self.get("CodigoCliente"),
                        tipoTransportadora: self.get("Transportadora").TipoTransportadora,
                        valorOrcamento: self.get("ValorTotalMercadorias"),
                        valorFrete: self.get("ValorFrete")
                    }),
                    success: function (response) {
                        global.blockUI(); // FNX-5538
                        if (response && response === true) {
                            $("#lbValorFrete").css("color", "#f25713 !important");
                            $("#valor-frete").addClass("erro");
                        } else {
                            $("#lbValorFrete").css("color", "#000 !important");
                            $("#valor-frete").removeClass("erro");
                        }
                        global.unblockUI(); // FNX-5538
                    }
                });
            });
        }
    },

    // sair: function () {
    //     // global.ajax({
    //     //     url: "/Orcamento/Sair",
    //     //     type: "post",
    //     //     async: false,
    //     //     blockUI: false,
    //     //     data: {
    //     //         identificadorOrcamento: this.get("IdentificadorOrcamento")
    //     //     }
    //     // });

    //     // global.sleep(500);

    // }

})

window.Orcamento = Orcamento

export {
    Orcamento,
    AcaoAposIncluirProdutos
}